import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";
import { StockReceiveDto } from "./stock-receive.dto";

export class ReceiveStockDto {
    @ApiProperty({ type: [StockReceiveDto]})
    @IsNotEmpty({message:"Recevied Stocks should not be empty"})
    receivedStocks: StockReceiveDto[];    
}